import { Translation, QRType } from '../types';

export const ar: Translation = {
  nav: {
    generator: 'المنشئ',
    scanner: 'الماسح',
    mobile: 'جرّبه على الجوال',
    blog: 'المدونة',
    langSelect: 'اختر اللغة',
  },
  pageTitles: {
    generator: 'منشئ رموز QR مجاني عبر الإنترنت',
    scanner: 'ماسح QR عبر الإنترنت',
    textToQr: 'تحويل النص إلى QR',
    linkToQr: 'إنشاء QR للرابط',
  },
  pageMeta: {
    generator: {
      title:
        'منشئ QR مجاني — أنشئ رموز QR عبر الإنترنت (بدون تسجيل، بدون علامة مائية، PNG/SVG/PDF) | YesQRCode',
      description:
        'أنشئ رموز QR عبر الإنترنت مجانًا باستخدام YesQRCode. يدعم الروابط والنص وWi‑Fi وvCard وغير ذلك. حمّل PNG/SVG/PDF بجودة عالية. بدون تسجيل أو دخول أو علامة مائية — سريع وآمن ومجاني للأبد.',
      keywords: [
        'منشئ qr',
        'منشئ qr مجاني',
        'إنشاء qr عبر الإنترنت',
        'صانع qr',
        'qr png',
        'qr svg',
        'qr pdf',
        'منشئ qr واي فاي',
        'منشئ qr vcard',
        'qr بدون تسجيل',
      ],
    },
    scanner: {
      title:
        'ماسح QR عبر الإنترنت — امسح من صورة أو كاميرا (آمن، بدون تسجيل) | YesQRCode',
      description:
        'امسح رموز QR والباركود مجانًا عبر الإنترنت. ارفع صورة أو استخدم الكاميرا. تتم المعالجة محليًا بدون رفع ملفات. سريع وآمن وبدون تسجيل.',
      keywords: [
        'ماسح qr',
        'مسح qr عبر الإنترنت',
        'قارئ qr عبر الإنترنت',
        'مسح qr من صورة',
        'مسح باركود عبر الإنترنت',
        'ماسح qr آمن',
        'ماسح qr بدون رفع',
        'ماسح qr مجاني',
        'ماسح qr في المتصفح',
        'ماسح qr بدون تسجيل',
      ],
    },
    textToQr: {
      title: 'نص إلى QR | حوّل الملاحظات إلى رموز QR',
      description:
        'حوّل النصوص والملاحظات والرسائل إلى رموز QR قابلة للمشاركة. خصّص التصميم وصدّر PNG/SVG/PDF فورًا بدون تسجيل.',
      keywords: ['نص إلى qr', 'منشئ qr للنص', 'ملاحظة qr', 'رسالة qr', 'محول qr عبر الإنترنت', 'qr نص مجاني'],
    },
    linkToQr: {
      title: 'رابط إلى QR | حوّل URL إلى رمز QR',
      description:
        'الصق أي رابط موقع أو حملة وأنشئ فورًا رمز QR جاهزًا للطباعة أو للاستخدام الرقمي. يدعم الألوان المخصصة والشعارات والتنزيل عالي الدقة.',
      keywords: ['رابط إلى qr', 'منشئ qr للروابط', 'qr للموقع', 'qr للرابط', 'utm qr', 'تنزيل qr pdf'],
    },
  },
  hero: {
    title: 'أنشئ رموز QR خاصة وجاهزة للعلامة التجارية — مجانًا للأبد.',
    subtitle: 'أداة QR سريعة وخاصة ومرنة تناسب أي سير عمل.',
    desc: 'أنشئ وامسح رموز QR عالية الجودة بدون حساب أو علامة مائية أو رفع بيانات.',
    ctaPrimary: 'إنشاء رمز QR',
    ctaSecondary: 'جرّبه على الجوال',
  },
  info: {
    helpTitle: 'مركز المساعدة',
    helpSubtitle: 'الأسئلة الشائعة والدعم',
    contactTitle: 'اتصل بنا',
    contactSubtitle: 'يسعدنا سماعك.',
    privacyTitle: 'سياسة الخصوصية',
    termsTitle: 'شروط الخدمة',
  },
  contactForm: {
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    message: 'الرسالة',
    send: 'إرسال',
    orEmail: 'أو راسلنا مباشرة على',
    sending: 'جارٍ الإرسال...',
    successTitle: 'تم الإرسال!',
    successMessage: 'شكرًا لتواصلك معنا. سنعود إليك قريبًا.',
    sendAnother: 'إرسال رسالة أخرى',
    errorMessage: 'تعذر إرسال رسالتك الآن. يرجى مراسلة support@yesqrcode.com.',
  },
  generator: {
    highlights: {
      title: 'أنشئ رموز QR خاصة وجاهزة للعلامة التجارية — مجانًا للأبد.',
      subtitle: 'أداة QR سريعة وخاصة ومرنة تناسب أي سير عمل.',
      items: [
        { title: 'الخصوصية أولاً (على الجهاز)', desc: 'يتم إنشاء رموز QR محليًا — بدون رفع أو تتبع أو تخزين.' },
        { title: 'ميزات لكل حالة استخدام', desc: 'روابط، Wi‑Fi، vCard، باركود، شعارات، تدرجات، إطارات.' },
        { title: 'سهل على الجوال', desc: 'محسن للهواتف ولمسات الشاشة لسهولة الإنشاء والمسح.' },
        { title: 'مجاني للأبد', desc: 'بدون حساب، بدون علامة مائية، بدون حدود للمسح.' },
      ],
    },
    featureSuite: {
      title: 'حزمة QR كاملة تركز على الخصوصية',
      subtitle: 'كل ما تحتاجه لإنشاء رموز QR نظيفة وجاهزة للعلامة التجارية وبجودة عالية — في مكان واحد.',
      categories: [
        {
          title: 'كل أنواع QR التي تحتاجها',
          body: 'روابط، نص، Wi‑Fi، بريد، هاتف، SMS، vCard، روابط اجتماعية، YouTube، باركود. رموز ثابتة لا تنتهي.',
          items: [],
        },
        { title: 'الهوية والتصميم', body: 'إضافة شعار بأمان، تدرجات، إطارات، أشكال وزوايا مع تحسين قابلية المسح.', items: [] },
        { title: 'الإخراج والجودة', body: 'تصدير PNG/SVG/PDF بجودة عالية مع إعدادات للطباعة والرقمي.', items: [] },
        { title: 'عالمي وسهل الاستخدام', body: 'واجهة متعددة اللغات وتصميم موبايل أولاً وسير عمل مناسب دون اتصال.', items: [] },
      ],
    },
    trust: {
      title: 'موثوق من صناع المحتوى والفرق والعلامات التجارية',
      subtitle:
        'YesQRCode مصمم ليكون خفيفًا وآمنًا للحملات طويلة الأمد — بدون حسابات أو قفل مزود أو قيود مخفية.',
      items: ['بدون إعداد', 'رموز ثابتة يمكن الاعتماد عليها', 'مناسب للشركات: بدون معالجة سحابية', 'هوية متسقة عبر الأصول'],
    },
    sectionContent: 'المحتوى',
    sectionColors: 'الألوان',
    sectionLogo: 'الشعار',
    sectionFrame: 'الإطار',
    sectionDesign: 'التصميم',
    sectionCorrection: 'تصحيح الخطأ',
    labelUrl: 'رابط الموقع',
    labelText: 'نص عادي',
    labelSsid: 'اسم الشبكة (SSID)',
    labelPassword: 'كلمة المرور',
    labelEncryption: 'التشفير',
    labelFgColor: 'لون المقدمة',
    labelBgColor: 'لون الخلفية',
    labelFrameText: 'نص الإطار',
    labelFrameColor: 'لون الإطار',
    placeholder: 'أدخل المحتوى هنا...',
    placeholders: {
      url: 'https://example.com',
      text: 'أدخل النص هنا',
      email: 'you@email.com',
      subject: 'الموضوع',
      message: 'رسالتك...',
      phone: '+966 5x xxx xxxx',
      ssid: 'MyWiFi',
      password: '***',
      barcode: '123456789012',
    },
    download: 'تنزيل PNG',
    downloadSvg: 'تنزيل SVG',
    generateButton: 'إنشاء QR',
    copy: 'نسخ SVG',
    uploadLogo: 'رفع صورة',
    preview: 'معاينة',
    lowQuality: 'جودة منخفضة',
    highQuality: 'جودة عالية',
    foreverFree: 'مجاني للأبد • بدون تسجيل • استخدام تجاري',
    barcodeWarning: 'خيارات التصميم المتقدمة مثل الإطارات والشعارات غير متاحة للباركود.',
    barcodeColors: 'يمكنك تخصيص الألوان أدناه.',
    frameStyles: {
      none: 'بدون',
      simple: 'بسيط',
      balloon: 'فقاعة',
      box: 'صندوق',
      badge: 'شارة',
      polaroid: 'بولارويد',
      phone: 'هاتف',
      header: 'ترويسة',
      corner: 'زاوية',
    },
    vCard: {
      firstName: 'الاسم الأول',
      lastName: 'اسم العائلة',
      mobile: 'جوال',
      phone: 'هاتف',
      fax: 'فاكس',
      email: 'البريد',
      company: 'الشركة',
      job: 'المسمى الوظيفي',
      street: 'الشارع',
      city: 'المدينة',
      zip: 'الرمز البريدي',
      state: 'المنطقة',
      country: 'الدولة',
      website: 'الموقع',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: 'نص',
      [QRType.EMAIL]: 'بريد',
      [QRType.PHONE]: 'هاتف',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'Wi‑Fi',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: 'باركود',
    },
    guide: { title: 'كيف تنشئ رمز QR مخصص؟', steps: [] },
    gettingStarted: {
      title: 'طريقة الاستخدام',
      steps: [
        { title: 'حدد محتوى QR', text: 'اختر نوع المحتوى (رابط، نص، بريد...). املأ الحقول التي تظهر عند المسح وتأكد من صحتها.' },
        { title: 'خصص التصميم', text: 'اختر ألوانًا وأشكالًا مخصصة، وأضف شعارًا من المعرض أو ارفعه من جهازك.' },
        { title: 'أنشئ الرمز', text: 'اضبط الدقة عبر شريط التمرير ثم قم بالتنزيل. افحص الرمز عبر مسحه من المعاينة.' },
        { title: 'نزّل الصورة', text: 'نزّل بصيغ PNG/SVG/PDF. اختر SVG إذا أردت صيغة متجهة. إعدادات الشعار/التصميم تعمل مع PNG وSVG.' },
      ],
    },
    about: {
      title: 'حزمة QR مجانية تركز على الخصوصية',
      subtitle: 'إنشاء ومسح QR بجودة عالية بدون حساب أو علامة مائية أو رفع بيانات.',
      features: [
        'يدعم الأنواع الشائعة: روابط، نص، Wi‑Fi، vCard، SMS والباركود',
        'إضافة شعار بأمان مع تصحيح خطأ يصل إلى 30%',
        'أشكال وتدرجات وألوان وإطارات مخصصة',
        'رموز ثابتة لا تنتهي',
        'واجهة متعددة اللغات',
      ],
      content: [
        { title: 'شعار آمن', body: 'أضف شعارك مع الحفاظ على قابلية المسح بفضل تصحيح الخطأ.' },
        { title: 'أشكال وإطارات', body: 'بدّل الأشكال واختر إطارًا يناسب حملتك مع الحفاظ على سهولة المسح.' },
        { title: 'أنواع متعددة', body: 'أنشئ روابط ونص وWi‑Fi وvCard وSMS والباركود من مكان واحد.' },
        { title: 'ثابت وطويل الأمد', body: 'رموز ثابتة لا تنتهي ولا تقيّد عدد مرات المسح.' },
      ],
    },
    faq: {
      title: 'الأسئلة الشائعة',
      items: [
        { q: 'ما هو رمز QR؟', a: 'QR هو اختصار لـ Quick Response Code، وهو نوع من الباركود ابتكرته Denso Wave عام 1994.' },
        { q: 'هل يمكنني استخدام الرموز تجاريًا؟', a: 'نعم، كل الرموز التي تنشئها هنا مجانية ويمكن استخدامها لأي غرض.' },
        { q: 'هل تنتهي صلاحية رموز QR؟', a: 'لا، فهي رموز ثابتة تعمل للأبد (لكن لا يمكنك تعديل المحتوى بعد الإنشاء).' },
        { q: 'هل هناك حد لعدد مرات المسح؟', a: 'لا يوجد حد؛ امسحه كما تشاء.' },
        { q: 'هل تحفظون بياناتي؟', a: 'لا نحفظ بياناتك أو نعيد استخدامها. قد يتم تخزين ملفات الصورة مؤقتًا لمدة 24 ساعة لتحسين الأداء.' },
        { q: 'لماذا لا تظهر حقول vCard بشكل صحيح؟', a: 'بعض الماسحات لا تتبع معيار vCard الرسمي بالكامل. جرّب ماسحًا آخر.' },
        { q: 'الرمز لا يعمل، ماذا أفعل؟', a: 'تحقق من البيانات، قلل المحتوى إذا كان كبيرًا، جرّب إزالة الشعار، وتأكد من وجود تباين كافٍ.' },
        { q: 'هل يعمل في كل المتصفحات؟', a: 'يتطلب متصفحًا حديثًا يدعم HTML5، ويدعم رسميًا Chrome وFirefox وSafari وEdge وInternet Explorer 11.' },
      ],
    },
  },
  scanner: {
    title: 'مسح QR والباركود',
    subtitle: 'استخدم الكاميرا أو ارفع صورة أو الصقها لفك ترميز QR والباركود فورًا.',
    cameraPermission: 'تم رفض إذن الكاميرا. يرجى تفعيل الإذن من إعدادات المتصفح.',
    result: 'النتيجة',
    copy: 'نسخ',
    copied: 'تم النسخ',
    open: 'فتح الرابط',
    delete: 'حذف',
    scanAgain: 'امسح مرة أخرى',
    privacy: 'تتم المعالجة محليًا داخل المتصفح. لا تغادر الملفات جهازك.',
    upload: 'رفع صورة',
    paste: 'لصق (Ctrl+V)',
    drop: 'أسقط الصورة هنا',
    retry: 'إعادة المحاولة',
    errorAccessDenied: 'تم رفض إذن الكاميرا',
    errorCamera: 'يرجى السماح بإذن الكاميرا في إعدادات المتصفح.',
    initializing: 'جارٍ تهيئة الكاميرا...',
    cameraActive: 'الكاميرا نشطة',
    scannedItems: 'العناصر الممسوحة',
    recentScans: 'الأخيرة (محليًا)',
    clickToUpload: 'انقر للرفع',
    newBadge: 'جديد',
    tabCameraMobile: 'الكاميرا',
    tabCameraDesktop: 'المسح عبر الكاميرا',
    emptyState: { title: 'لا توجد عمليات مسح بعد', desc: 'ارفع صورة أو استخدم تبويب الكاميرا للبدء.' },
    highlights: {
      title: 'مسح سريع وخاص',
      items: [
        { title: 'فك ترميز على الجهاز', desc: 'بدون رفع افتراضيًا — مناسب للمحتوى الحساس.' },
        { title: 'يدعم صيغًا متعددة', desc: 'QR بالإضافة إلى UPC/EAN وCode 128 وITF وغيرها.' },
        { title: 'إجراءات سريعة', desc: 'اسحب الملفات أو الصق لقطات الشاشة أو بدّل للمسح المباشر.' },
        { title: 'ممتاز على الجوال', desc: 'واجهة وتدفق كاميرا محسّنان للشاشات الصغيرة.' },
      ],
    },
    intro: { title: 'ماسح QR والباركود عبر الإنترنت', body: 'فك ترميز QR وUPC وEAN وغيرها مباشرة داخل المتصفح بدون تطبيق.' },
    howTo: {
      title: 'كيف تمسح؟',
      methods: [
        { title: 'الطريقة 1: الرفع', steps: ['انقر رفع صورة', 'اختر QR/باركود', 'احصل على النتيجة فورًا'] },
        { title: 'الطريقة 2: الكاميرا', steps: ['افتح تبويب الكاميرا', 'امنح الإذن', 'وجّه إلى QR/باركود'] },
      ],
    },
    features: {
      title: 'لماذا هذا الماسح؟',
      items: [
        { title: 'سجل محلي', desc: 'تُحفظ آخر النتائج على جهازك فقط لتسهيل النسخ أو الفتح لاحقًا.' },
        { title: 'فك ترميز الصور دون اتصال', desc: 'الرفع/اللصق يعملان حتى عند انقطاع الاتصال.' },
        { title: 'إجراءات فورية', desc: 'انسخ أو افتح أو احذف النتائج بسرعة.' },
      ],
    },
    useCases: {
      title: 'حالات استخدام شائعة',
      items: [
        { title: 'التجزئة والتسوق', desc: 'تحقق من روابط المنتجات أو القسائم أو التعليمات.' },
        { title: 'فرق المخزون', desc: 'تحقق من الباركود وأدر تحديثات المخزون.' },
        { title: 'المستخدمون', desc: 'افتح القوائم وروابط Wi‑Fi وبطاقات الاتصال بسرعة.' },
      ],
    },
    faq: {
      title: 'أسئلة الماسح',
      items: [
        { q: 'هل يمكنني مسح الباركود؟', a: 'نعم، يدعم QR وCode 128 وUPC وEAN وITF وغيرها.' },
        { q: 'هل تخزنون عمليات المسح؟', a: 'لا، تبقى النتائج على جهازك ولا تغادر المتصفح.' },
        { q: 'هل يمكن لصق لقطات الشاشة؟', a: 'نعم، استخدم Ctrl+V (Cmd+V) للصق من الحافظة.' },
        { q: 'هل يعمل دون اتصال؟', a: 'رفع الصور يعمل دون اتصال؛ المسح بالكاميرا يحتاج إذنًا ومتصفحًا مدعومًا.' },
      ],
    },
  },
  blog: {
    title: 'مقالات وإرشادات',
    subtitle: 'أفضل الممارسات وأفكار التسويق وتحديثات المنتج لتجارب QR.',
    readMore: 'اقرأ المقال',
    back: 'العودة للمدونة',
    notFound: 'المقال غير موجود',
  },
  common: {
    footer: 'حزمة قوية لإنشاء رموز QR للمسوقين والمصممين والفرق.',
    privacy: 'الخصوصية',
    terms: 'الشروط',
    contact: 'تواصل',
    scanToOpen: 'امسح لفتحه على الجوال',
    help: 'مساعدة',
    free: 'مجاني',
    product: 'المنتج',
    resources: 'الموارد',
    company: 'الشركة',
    api: 'واجهة API (قريبًا)',
    systemStatus: 'الأنظمة تعمل',
    footerDesc: 'أقوى منشئ وماسح QR. سريع، يركز على الخصوصية، ومجاني للأبد للاستخدام الشخصي والتجاري.',
  },
};

